export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-full bg-brandgreen px-7 py-3.5 text-white font-semibold shadow-lg shadow-brandgreen/25 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-brandgreen-dark active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-brandgreen focus-visible:ring-offset-2";

export const btnOutlineNavy =
  "inline-flex items-center justify-center gap-2 rounded-full border-2 border-navy px-7 py-3.5 text-navy font-semibold transition-colors duration-200 hover:bg-navy hover:text-white active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2";

export const btnWhite =
  "inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 text-navy font-semibold shadow-lg transition-transform duration-200 hover:-translate-y-0.5 active:scale-95";

export const btnOutlineWhite =
  "inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/70 px-7 py-3.5 text-white font-semibold transition-colors duration-200 hover:bg-white hover:text-navy active:scale-95";

export const btnSmall =
  "inline-flex items-center justify-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-200";

export const sectionPad = "py-20 lg:py-28";
export const container = "mx-auto w-full max-w-7xl px-5 sm:px-8";
export const label =
  "text-xs tracking-[0.22em] uppercase font-semibold text-brandgreen";
export const cardShadow = "shadow-[0_8px_32px_rgba(15,61,94,0.08)]";
